import { createAction } from 'app-components/flux/core/actionHelpers';

import type { UndoDeferToken, UndoProps } from './undoTypes';

const identity = (undo: UndoProps): UndoProps => undo;

export const addUndo = createAction('ADD_UNDO', identity);
export const undo = createAction('UNDO', identity);
export const deleteUndo = createAction('DELETE_UNDO', identity);
/** Shows the deferred undo carrying this token, now that the work it reverts has finished. */
export const revealUndo = createAction<UndoDeferToken>('REVEAL_UNDO');
